export function scopeHelper(object, scopeValue) {
  return (
    object &&
    object.scope &&
    (object.scope === process.env.SCOPE || object.scope === scopeValue)
  );
}
